import type { components } from "@/api/schema";
import { repeatLabel, repeatTone } from "./model";

type Repeat = components["schemas"]["Repeat"];

/** «Повторяющиеся замечания» — N× по причинам возвратов (reason_tag комментариев). */
export function Repeats({ repeats }: { repeats: Repeat[] }) {
  const max = Math.max(1, ...repeats.map((r) => r.count));
  return (
    <section className="rounded-lg border border-bd bg-card px-4 py-3.5" data-testid="repeats">
      <div className="mb-2.5 font-mono text-[10.5px] uppercase tracking-[.06em] text-mut">повторяющиеся замечания</div>
      {repeats.length === 0 ? (
        <p className="m-0 font-mono text-[12px] leading-[1.5] text-mut" data-testid="repeats-empty">
          Повторов нет — ни одна причина возврата не встречалась дважды.
        </p>
      ) : (
        <ul className="m-0 flex list-none flex-col gap-2.5 p-0">
          {repeats.map((r) => {
            const tone = repeatTone(r.count);
            return (
              <li key={r.reason.slug} data-testid="repeat" className="flex flex-col gap-1">
                <span className="flex items-baseline justify-between gap-3 text-[12.5px] text-ink">
                  <span>{r.reason.label}</span>
                  <span className={`font-mono text-[12px] font-semibold ${tone === "err" ? "text-err" : "text-warn"}`} data-testid="repeat-count">
                    {repeatLabel(r.count)}
                  </span>
                </span>
                <span className="h-1 w-full rounded-[2px] bg-card2" aria-hidden>
                  <span className="block h-1 rounded-[2px]" style={{ width: `${(r.count / max) * 100}%`, background: `var(--${tone})` }} />
                </span>
              </li>
            );
          })}
        </ul>
      )}
      <p className="mb-0 mt-3 text-[12px] leading-[1.5] text-ink2">Три повтора одного замечания — сигнал, что дело не в задаче, а в пробеле темы.</p>
    </section>
  );
}
